// eslint-disable-next-line import/named
import { SxProps } from '@mui/material'
import { COLORS } from '../../../styles/variables'

/** Match react-toastify mobile breakpoint (full-bleed left:0 override). */
const TOASTIFY_MOBILE_MAX = '480px'

export const toastStyles: SxProps = {
  '&': {
    '@keyframes Toastify__toastSlideDownIn': {
      from: {
        transform: 'translate3d(0, -120%, 0)',
        opacity: 0,
      },
      to: {
        transform: 'translate3d(0, 0, 0)',
        opacity: 1,
      },
    },
    '@keyframes Toastify__toastSlideDownOut': {
      from: {
        transform: 'translate3d(0, 0, 0)',
        opacity: 1,
      },
      to: {
        transform: 'translate3d(0, -120%, 0)',
        opacity: 0,
      },
    },
    '.Toastify__toast-slide-down-enter--top-right': {
      animationFillMode: 'both',
      animationDuration: '280ms',
      animationTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
      animationName: 'Toastify__toastSlideDownIn',
    },
    '.Toastify__toast-slide-down-exit--top-right': {
      animationFillMode: 'both',
      animationDuration: '260ms',
      animationTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
      animationName: 'Toastify__toastSlideDownOut',
    },

    '.Toastify__toast-container': {
      maxWidth: '360px',
      width: '100%',
      minHeight: '52px',
      [`@media (max-width: ${TOASTIFY_MOBILE_MAX})`]: {
        // Override toastify mobile full-bleed (left:0, width:100vw).
        left: '50% !important',
        right: 'auto !important',
        transform: 'translateX(-50%) !important',
        width: 'calc(100% - 32px) !important',
        maxWidth: '360px',
        padding: '0 !important',
        margin: '0 !important',
        top: '12px',
      },
    },
    '.Toastify__toast-container--top-right': {
      [`@media (max-width: ${TOASTIFY_MOBILE_MAX})`]: {
        left: '50% !important',
        right: 'auto !important',
        transform: 'translateX(-50%) !important',
      },
    },
    '.Toastify__toast': {
      bgcolor: COLORS.CERULEAN,
      borderRadius: 1,
      fontWeight: 700,
      lineHeight: '20px',
      minHeight: '44px',
      paddingY: 0,
      paddingX: 2.5,
      position: 'relative',
      '&--success': {
        bgcolor: COLORS.STOPLIGHT_GO_GREEN,
      },
      '&--error': {
        bgcolor: COLORS.CADMIUM_RED,
      },
      [`@media (max-width: ${TOASTIFY_MOBILE_MAX})`]: {
        // Keep pill shape; toastify sets border-radius: 0 on mobile.
        borderRadius: '8px !important',
        marginBottom: '8px',
      },
    },
    '.Toastify__close-button': {
      alignSelf: 'center',
      opacity: 1,
      color: COLORS.WHITE,
    },
    '.Toastify__close-button > svg': {
      width: '18px',
      height: '18px',
    },
    '.Toastify__toast-icon': {
      display: 'none',
    },
    '.Toastify__toast-body': {
      padding: '0px',
      paddingRight: '8px',
      color: COLORS.WHITE,
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '500',
    },
  },
}
